import React from 'react';
import { useState } from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Collapse } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

import { RiskSegment } from './RiskSegment';
import { Title } from '@/components/Typography';
import { TaskRiskTable } from './TaskRiskTable';
import { PercentageBarRisk } from './PercentageBarRisk';
import { TasksResult } from '@/core/domain/owas-report';
import * as S from './styles';

interface TaskRiskProps {
	data: TasksResult[];
}

const { Panel } = Collapse;

export function TaskRisk({ data = [] }: Readonly<TaskRiskProps>): JSX.Element {
	const [isOpen, setIsOpen] = useState<string>('');

	function handleOpenTask(taskId: string): void {
		setIsOpen(taskId === isOpen ? '' : taskId);
	}

	return (
		<Row gutter={[0, 10]}>
			<Col span={24}>
				<Title level={2}>Risk of the tasks</Title>
			</Col>
			<Col span={24}>
				<Row>
					{data.map((task) => (
						<Col span={24} key={task.id} style={{ marginTop: '0.2rem', position: 'relative' }}>
							<Row
								align="middle"
								justify="space-between"
								style={{ position: 'relative', zIndex: 1 }}
								onClick={() => handleOpenTask(task.id)}
							>
								<Col flex="none">
									<S.StyledButton>
										{task.id === isOpen ? <UpOutlined /> : <DownOutlined />}
									</S.StyledButton>
								</Col>
								<Col flex="auto">
									<Title level={4} style={{ marginLeft: '20px', marginBottom: 0 }}>
										{task.name}
									</Title>
								</Col>
								<Col flex="none">
									<S.FrequencyLabel>
										<span>
											<strong>{I18n.get('Frequency')}:</strong> {task.frequency}
										</span>
									</S.FrequencyLabel>
								</Col>
							</Row>
							<Collapse activeKey={isOpen} ghost>
								<Panel showArrow={false} header={null} key={task.id}>
									<S.Content justify="space-between">
										<S.InformationsContainer>
											<S.InformationInnerLeftContainer>
												<Title level={5} style={{ margin: 0 }}>
													Manual tools
												</Title>
											</S.InformationInnerLeftContainer>
											<S.InformationInnerRightContainer>
												<p>{task.activity_tools}</p>
											</S.InformationInnerRightContainer>
										</S.InformationsContainer>
										<Row gutter={[0, 10]} style={{ marginTop: '2rem', marginBottom: '1rem' }}>
											<Col span={24}>
												<Title level={4}>Overall task risk</Title>
											</Col>
										</Row>
										<PercentageBarRisk risk={task.overall_task_risk} />
										<TaskRiskTable risk={task.overall_task_risk} />
										<RiskSegment segments={task.risk_by_segment} />
									</S.Content>
								</Panel>
							</Collapse>
						</Col>
					))}
				</Row>
			</Col>
		</Row>
	);
}
